import React, { useEffect, useState } from 'react';
import {
    Tabs,
    Table,
    Button,
    Modal,
    Form,
    Input,
    Select,
    Space,
    Tag,
    Popconfirm,
    Switch,
    Card,
    Row,
    Col,
    Typography,
    Checkbox,
    Avatar,
    Tooltip,
    message,
    Badge
} from 'antd';
import {
    UserOutlined,
    SafetyOutlined,
    DesktopOutlined,
    PlusOutlined,
    EditOutlined,
    DeleteOutlined,
    EyeOutlined,
    LockOutlined,
    UnlockOutlined,
    SearchOutlined,
    LockFilled
} from '@ant-design/icons';
import { createroleApi, createScreenApi, getAllRoleApi, getAllScreensApi, getAllUserApi, signupapi, updateRoleByIdApi, updateScreenByIdApi } from '../../redux/api/api';
import '../AccessControl/control.css'
const { Title, Text } = Typography;
const { Option } = Select;
const { Search } = Input;


const AccessControlManagement = () => {
    const [activeTab, setActiveTab] = useState('users');
    const [userModalVisible, setUserModalVisible] = useState(false);
    const [roleModalVisible, setRoleModalVisible] = useState(false);
    const [screenModalVisible, setScreenModalVisible] = useState(false);
    const [editingUser, setEditingUser] = useState(null);
    const [editingRole, setEditingRole] = useState(null);
    const [editingScreen, setEditingScreen] = useState(null);
    const [form] = Form.useForm();
    const [searchText, setSearchText] = useState('');
    const { CheckableTag } = Tag;
    const roundCheckboxStyle = {
        borderRadius: "50%",          // makes circle
        width: "20px",
        height: "20px",
    };
    // Mock data (already present in your snippet)
    // const [users, setUsers] = useState([
    //     { id: 1, name: 'John Smith', email: 'john.smith@company.com', role: 'Admin', status: 'Active', lastLogin: '2024-01-15 10:30', avatar: 'JS', department: 'IT', phone: '+1-234-567-8901' },
    //     { id: 2, name: 'Sarah Johnson', email: 'sarah.johnson@company.com', role: 'Manager', status: 'Active', lastLogin: '2024-01-14 16:45', avatar: 'SJ', department: 'HR', phone: '+1-234-567-8902' },
    //     { id: 3, name: 'Mike Davis', email: 'mike.davis@company.com', role: 'User', status: 'Inactive', lastLogin: '2024-01-10 09:15', avatar: 'MD', department: 'Sales', phone: '+1-234-567-8903' },
    //     { id: 4, name: 'Emily Wilson', email: 'emily.wilson@company.com', role: 'Manager', status: 'Active', lastLogin: '2024-01-14 14:20', avatar: 'EW', department: 'Finance', phone: '+1-234-567-8904' },
    //     { id: 5, name: 'David Brown', email: 'david.brown@company.com', role: 'User', status: 'Active', lastLogin: '2024-01-15 08:45', avatar: 'DB', department: 'Marketing', phone: '+1-234-567-8905' }
    // ]);
    const [users, setUsers] = useState([
        // { id: 1, name: 'John Smith', email: 'john.smith@company.com', role: 'Admin', status: 'Active', lastLogin: '2024-01-15 10:30', avatar: 'JS', department: 'IT', phone: '+1-234-567-8901' },
        // { id: 2, name: 'Sarah Johnson', email: 'sarah.johnson@company.com', role: 'Manager', status: 'Active', lastLogin: '2024-01-14 16:45', avatar: 'SJ', department: 'HR', phone: '+1-234-567-8902' },
        // { id: 3, name: 'Mike Davis', email: 'mike.davis@company.com', role: 'User', status: 'Inactive', lastLogin: '2024-01-10 09:15', avatar: 'MD', department: 'Sales', phone: '+1-234-567-8903' },
        // { id: 4, name: 'Emily Wilson', email: 'emily.wilson@company.com', role: 'Manager', status: 'Active', lastLogin: '2024-01-14 14:20', avatar: 'EW', department: 'Finance', phone: '+1-234-567-8904' },
        // { id: 5, name: 'David Brown', email: 'david.brown@company.com', role: 'User', status: 'Active', lastLogin: '2024-01-15 08:45', avatar: 'DB', department: 'Marketing', phone: '+1-234-567-8905' }
    ]);

    // console.log(users)
    // const [roles, setRoles] = useState([
    //     { id: 1, name: 'Admin', description: 'Full system access with all permissions including user management and system configuration', permissions: ['create', 'read', 'update', 'delete', 'manage_users', 'manage_roles', 'system_config'], userCount: 1, status: 'Active', createdDate: '2024-01-01', color: 'red' },
    //     { id: 2, name: 'Manager', description: 'Departmental management with limited admin rights and team oversight capabilities', permissions: ['create', 'read', 'update', 'manage_team', 'view_reports'], userCount: 3, status: 'Active', createdDate: '2024-01-01', color: 'blue' },
    //     { id: 3, name: 'User', description: 'Basic user access for daily operations with limited modification rights', permissions: ['read', 'update_own', 'create_basic'], userCount: 15, status: 'Active', createdDate: '2024-01-01', color: 'green' },
    //     { id: 4, name: 'Viewer', description: 'Read-only access for viewing data without modification capabilities', permissions: ['read'], userCount: 5, status: 'Active', createdDate: '2024-01-05', color: 'orange' }
    // ]);
    const [roles, setRoles] = useState([]); // start empty (dynamic)
    // console.log(roles)
    // const [screens, setScreens] = useState([
    //     { id: 1, name: 'Dashboard', path: '/dashboard', description: 'Main application dashboard with overview metrics and quick actions', roles: ['Admin', 'Manager', 'User'], status: 'Active', category: 'Main', icon: 'DashboardOutlined' },
    //     { id: 2, name: 'User Management', path: '/admin/users', description: 'Comprehensive user management interface for system administrators', roles: ['Admin'], status: 'Active', category: 'Admin', icon: 'UserOutlined' },
    //     { id: 3, name: 'Reports', path: '/reports', description: 'Generate and view detailed reports and analytics', roles: ['Admin', 'Manager'], status: 'Active', category: 'Analytics', icon: 'BarChartOutlined' },
    //     { id: 4, name: 'Settings', path: '/settings', description: 'System configuration and preference management', roles: ['Admin'], status: 'Inactive', category: 'Admin', icon: 'SettingOutlined' },
    //     { id: 5, name: 'Profile', path: '/profile', description: 'Personal profile management and account settings', roles: ['Admin', 'Manager', 'User', 'Viewer'], status: 'Active', category: 'Personal', icon: 'ProfileOutlined' },
    //     { id: 6, name: 'Team Management', path: '/team', description: 'Manage team members and departmental operations', roles: ['Manager'], status: 'Active', category: 'Management', icon: 'TeamOutlined' }
    // ]);

    const [screens, setScreens] = useState([]);
    // console.log(screens)
    const [permissions, setPermissions] = useState([]);


    useEffect(() => {
        if (roleModalVisible) {
            if (editingRole) {
                setPermissions(
                    screens.map((screen) => ({
                        screenId: screen._id,
                        screenName: screen.name,
                        create: editingRole.permissions?.includes(`create${screen.name}Management`) || false,
                        read: editingRole.permissions?.includes(`read${screen.name}Management`) || false,
                        update: editingRole.permissions?.includes(`update${screen.name}Management`) || false,
                        delete: editingRole.permissions?.includes(`delete${screen.name}Management`) || false,
                    }))
                );

                // fill other fields
                form.setFieldsValue({
                    name: editingRole.name,
                    description: editingRole.description,
                    status: editingRole.status === "Active",
                });
            } else {
                // 🔹 Add Role → all checkboxes unchecked
                setPermissions(
                    screens.map((screen) => ({
                        screenId: screen._id,
                        screenName: screen.name,
                        create: false,
                        read: false,
                        update: false,
                        delete: false,
                    }))
                );
                form.resetFields();
            }
        }
    }, [roleModalVisible, editingRole, screens]);

    const [options, setOptions] = useState([
        { id: 1, name: 'access' },
        { id: 2, name: 'create' },
        { id: 3, name: 'read' },
        { id: 3, name: 'update' },
        { id: 3, name: 'delete' },
    ])

    const availableRoles = ['Admin', 'Manager', 'User', 'Viewer', 'Guest'];

    const departments = ['IT', 'HR', 'Sales', 'Finance', 'Marketing', 'Operations'];

    const handleChange = (screenId, key, checked) => {
        setPermissions((prev) =>
            prev.map((item) =>
                item.screenId === screenId ? { ...item, [key]: checked } : item
            )
        );
    };

    const handleSelectAll = (key, checked) => {
        setPermissions((prev) =>
            prev.map((item) => ({ ...item, [key]: checked }))
        );
    };

    // Select All in one row
    const handleSelectRow = (screenId, checked) => {
        setPermissions((prev) =>
            prev.map((item) =>
                item.screenId === screenId
                    ? {
                        ...item,
                        create: checked,
                        read: checked,
                        update: checked,
                        delete: checked,
                    }
                    : item
            )
        );

    };

    const handleSelectAllGlobal = (checked) => {
        setPermissions((prev) =>
            prev.map((item) => ({
                ...item,
                create: checked,
                read: checked,
                update: checked,
                delete: checked,
            }))
        );
    };

    const columns = [
        {
            title: "Screen Name",
            dataIndex: "screenName",
            key: "screenName",
            render: (text) => (
                <span
                    style={{
                        background: "#f5f7fb",
                        padding: "4px 10px",
                        borderRadius: "6px",
                        fontSize: "13px",
                    }}
                >
                    {text}
                </span>
            ),
            width: 150,
        },
        {
            title: "Create",
            key: "create",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={record.create}
                    onChange={(e) =>
                        handleChange(record.screenId, "create", e.target.checked)
                    }
                />
            ),
        },
        {
            title: "Read",
            key: "read",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={record.read}
                    onChange={(e) =>
                        handleChange(record.screenId, "read", e.target.checked)
                    }
                />
            ),
        },
        {
            title: "Update",
            key: "update",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={record.update}
                    onChange={(e) =>
                        handleChange(record.screenId, "update", e.target.checked)
                    }
                />
            ),
        },
        {
            title: "Delete",
            key: "delete",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={record.delete}
                    onChange={(e) =>
                        handleChange(record.screenId, "delete", e.target.checked)
                    }
                />
            ),
        },
        {
            title: "All",
            key: "all",
            align: "center",
            render: (_, record) => (
                <Checkbox
                    checked={
                        record.create && record.read && record.update && record.delete
                    }
                    indeterminate={
                        (record.create || record.read || record.update || record.delete) &&
                        !(record.create && record.read && record.update && record.delete)
                    }
                    onChange={(e) => handleSelectRow(record.screenId, e.target.checked)}
                />
            ),
        },
    ];


    useEffect(() => {
        handleGetRoles();
        getAllScreens();
        getAllUsers();
    }, []);
    // --------- User Management Functions (already in your snippet) ----------
    const handleUserSubmit = async (values) => {
        if (editingUser) {
            setUsers(users.map(user =>
                user.id === editingUser.id
                    ? { ...user, ...values, id: editingUser.id }
                    : user
            ));
            message.success('User updated successfully');
        } else {
            const newUser = {
                id: Date.now(),
                ...values,
                lastLogin: 'Never',
                avatar: values.name ? values.name.split(' ').map(n => n[0]).join('') : 'U'
            };

            setUsers([...users, newUser]);

            try {
                await signupapi(values);
            } catch (error) {
                console.error(error);
                message.error('User creation failed');
            }
        }

        setUserModalVisible(false);
        setEditingUser(null);
        form.resetFields();
    };


    const handleDeleteUser = (id) => {
        setUsers(users.filter(user => user.id !== id));
        message.success('User deleted successfully');
    };

    const toggleUserStatus = (id) => {
        setUsers(users.map(user =>
            user.id === id
                ? { ...user, status: user.status === 'Active' ? 'Inactive' : 'Active' }
                : user
        ));
        message.success('User status updated');
    };

    // --------- Role Management Functions ----------

    const handleRoleSubmit = async (data) => {
        // console.log(data)
        const permissionList = permissions.flatMap((perm) => {
            const keys = [];
            const cleanName = perm.screenName.replace(/\s+/g, ''); // remove all spaces

            if (perm.create) keys.push(`create${cleanName}Management`);
            if (perm.read) keys.push(`read${cleanName}Management`);
            if (perm.update) keys.push(`update${cleanName}Management`);
            if (perm.delete) keys.push(`delete${cleanName}Management`);

            return keys;
        });
        const roleData = {
            name: data.name,
            description: data.description,
            status: data.status ? "Active" : "Inactive",
            permissions: permissionList, // ✅ array of strings
        };
        //console.log("Submitting Role:", roleData);
        // return
        try {
            if (editingRole) {
                await updateRoleByIdApi({ ...roleData, id: editingRole._id || editingRole.id });
                alert("Role updated successfully");
                handleGetRoles()
            } else {
                await createroleApi(roleData)
                alert("Role created successfully");
                handleGetRoles()
            }
        } catch (error) {
            console.error(error);
            message.error("Something went wrong");
        } finally {
            setRoleModalVisible(false);
            setEditingRole(null);
            form.resetFields();
        }
    };

    const handleGetRoles = async () => {
        try {
            const res = await getAllRoleApi();
            setRoles(res.data);
        } catch (error) {
            console.error("Error fetching roles:", error);
            message.error("Failed to fetch roles");
        }
    };

    const handleDeleteRole = (id) => {
        const role = roles.find(r => r.id === id);
        if (role.userCount > 0) {
            message.error('Cannot delete role that has assigned users');
            return;
        }
        setRoles(roles.filter(role => role.id !== id));
        message.success('Role deleted successfully');
    };

    const handleScreenSubmit = async (values) => {
        //console.log(values)
        const screenData = {
            ...values,
            id: editingScreen ? editingScreen.id : Date.now(),

        };
        try {
            if (editingScreen) {
                await updateScreenByIdApi(screenData); // call API
                setScreens(screens.map(screen =>
                    screen.id === editingScreen.id
                        ? screenData
                        : screen
                ));
                message.success('Screen updated successfully');
            } else {
                await createScreenApi(screenData); // call API
                setScreens([...screens, screenData]);
                alert('Screen created successfully');
                getAllScreens();
            }
        } catch (error) {
            console.error(error);
            message.error('Something went wrong');
        } finally {
            setScreenModalVisible(false);
            setEditingScreen(null);
            form.resetFields();
        }
    };


    const handleDeleteScreen = (id) => {
        setScreens(screens.filter(screen => screen.id !== id));
        message.success('Screen deleted successfully');
    };

    const getAllScreens = async () => {
        try {
            const res = await getAllScreensApi();
            setScreens(res.data.screens);
        } catch (error) {
            console.error("Error fetching roles:", error);
            message.error("Failed to fetch roles");
        }
    }


    const getAllUsers = async () => {
        try {
            const res = await getAllUserApi();
            const normalizedUsers = res.data.info.map(u => ({
                ...u,
                name: u.name || u.fullName || "",   // unify name
                role: u.role || "",                 // ensure role always exists
                email: u.email || ""
            }));
            setUsers(normalizedUsers);
        } catch (error) {
            console.error("Error fetching roles:", error);
            message.error("Failed to fetch roles");
        }
    };


    // --------- Filters ----------
    const filteredUsers = users.filter(user =>
        user.name.toLowerCase().includes(searchText.toLowerCase()) ||
        user.email.toLowerCase().includes(searchText.toLowerCase())
            (user.role || '').toLowerCase().includes(searchText.toLowerCase())
    );

    const filteredRoles = roles.filter(role =>
        role.name.toLowerCase().includes(searchText.toLowerCase()) ||
        (role.description || '').toLowerCase().includes(searchText.toLowerCase())
    );

    const filteredScreens = screens.filter(screen =>
        screen.name.toLowerCase().includes(searchText.toLowerCase()) ||
        (screen.path || '').toLowerCase().includes(searchText.toLowerCase()) ||
        (screen.category || '').toLowerCase().includes(searchText.toLowerCase())
    );

    // --------- Table columns (userColumns, roleColumns, screenColumns) ----------
    const userColumns = [
        {
            title: 'User',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Space>
                    <Badge status={record.status === true ? 'success' : 'error'} dot>
                        {/* <Avatar style={{ backgroundColor: '#1890ff' }}>{record.avatar}</Avatar> */}
                        <Avatar style={{ backgroundColor: '#1890ff' }}>
                            {record.avatar ||
                                (record.fullName || record.name || "")
                                    .split(" ")
                                    .map(word => word[0])
                                    .join("")
                                    .toUpperCase() || "U"}
                        </Avatar>

                    </Badge>
                    <div>
                        <div style={{ fontWeight: 'bold' }}>{text}</div>
                        <Text type="secondary" style={{ fontSize: 12 }}>{record.email}</Text>
                    </div>
                </Space>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Role',
            dataIndex: 'role',
            key: 'role',
            render: role => {
                const roleInfo = roles.find(r => r.name === role);
                return <Tag color={roleInfo?.color || 'blue'}>{role}</Tag>;
            },
            filters: availableRoles.map(role => ({ text: role, value: role })),
            onFilter: (value, record) => record.role === value,
        },

        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status, record) => (
                <Switch
                    checked={status === true}
                    onChange={() => toggleUserStatus(record.id)}
                    checkedChildren="Active"
                    unCheckedChildren="Inactive"
                />
            ),
            filters: [{ text: 'Active', value: 'Active' }, { text: 'Inactive', value: 'Inactive' }],
            onFilter: (value, record) => record.status === value,
        },
        {
            title: 'Last Login',
            dataIndex: 'lastLogin',
            key: 'lastLogin',
            render: login => (
                <Text type={!login ? 'secondary' : 'default'}>
                    {!login ? 'Never' : new Date(login).toLocaleString()}
                </Text>
            ),
            sorter: (a, b) => {
                const da = !a.lastLogin ? 0 : new Date(a.lastLogin).getTime();
                const db = !b.lastLogin ? 0 : new Date(b.lastLogin).getTime();
                return da - db;
            },
        },

        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title="View Details"><Button icon={<EyeOutlined />} size="small" /></Tooltip>
                    <Tooltip title="Edit User">
                        <Button
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => {
                                setEditingUser(record);
                                form.setFieldsValue(record);
                                setUserModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete User">
                        <Popconfirm
                            title="Are you sure you want to delete this user?"
                            description="This action cannot be undone."
                            onConfirm={() => handleDeleteUser(record.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<DeleteOutlined />} size="small" danger />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
            width: 150,
        }
    ];

    const roleColumns = [
        {
            title: 'Role',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <Space>
                    <Tag color={record.color}>{text}</Tag>
                    {/* <Text strong>{text}</Text> */}
                </Space>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
            ellipsis: true,
            render: text => <Text>{text}</Text>,
            width: 200,
        },
        {
            title: 'Permissions',
            dataIndex: 'permissions',
            key: 'permissions',
            render: permissions => (
                <div>
                    {(permissions || []).slice(0, 2).map(permission => (
                        <Tag key={permission} color="geekblue" style={{ marginBottom: 2 }}>
                            {permission.replace('_', ' ')}
                        </Tag>
                    ))}
                    {permissions && permissions.length > 2 && (
                        <Tag color="default">+{permissions.length - 2} more</Tag>
                    )}
                </div>

            ),
            width: 300,
        },
        {
            title: 'Users',
            dataIndex: 'userCount',
            key: 'userCount',
            render: count => <Badge count={count} style={{ backgroundColor: count > 0 ? '#52c41a' : '#d9d9d9' }} showZero />,
            sorter: (a, b) => a.userCount - b.userCount,
        },
        {
            title: 'Created',
            dataIndex: 'createdDate',
            key: 'createdDate',
            // render: date => <Text type="secondary">{date}</Text>,
            render: (date) => {
                const istDate = new Date(date).toLocaleString("en-IN", {
                    timeZone: "Asia/Kolkata",
                    year: "numeric",
                    month: "2-digit",
                    day: "2-digit",
                    hour: "2-digit",
                    minute: "2-digit",
                    second: "2-digit",
                });
                return <Text type="secondary">{istDate}</Text>;
            },
            sorter: (a, b) => new Date(a.createdDate) - new Date(b.createdDate),
            width: 200
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (status) => {
                const isActive = status === "true" || status === 'Active';
                return (
                    <Tag color={isActive ? 'green' : 'red'}>
                        {isActive ? 'Active' : 'Inactive'}
                    </Tag>
                );
            },
            filters: [
                { text: 'Active', value: true },
                { text: 'Inactive', value: false }
            ],
            onFilter: (value, record) =>
                record.status === value ||
                record.status === (value ? 'Active' : 'Inactive'),
        },

        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit Role">
                        <Button
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => {
                                setEditingRole(record);
                                form.setFieldsValue(record);
                                setRoleModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete Role">
                        <Popconfirm
                            title="Are you sure you want to delete this role?"
                            description={record.userCount > 0 ? `This role has ${record.userCount} assigned users. Please reassign them first.` : "This action cannot be undone."}
                            onConfirm={() => handleDeleteRole(record.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<DeleteOutlined />} size="small" danger disabled={record.userCount > 0} />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
            width: 120,
        }
    ];

    const screenColumns = [
        {
            title: 'Screen',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div>
                    <Text strong>{text}</Text><br />
                    {/* <Tag color="volcano" style={{ fontSize: 11 }}>{record.category}</Tag> */}
                </div>
            ),
            sorter: (a, b) => a.name.localeCompare(b.name),
        },
        {
            title: 'Path',
            dataIndex: 'path',
            key: 'path',
            render: path => <code style={{ background: '#f5f5f5', padding: '2px 6px', borderRadius: 3, fontSize: 12 }}>{path}</code>
        },
        { title: 'Description', dataIndex: 'description', key: 'description', ellipsis: true },
        {
            title: 'Options',
            dataIndex: 'roles',
            key: 'roles',
            render: rls => (
                <div>
                    {rls && rls.map((role, index) => (
                        <Tag key={index} color="blue" style={{ marginBottom: 4 }}>
                            {role}
                        </Tag>
                    ))}
                </div>
            ),
            width: 200,
        },


        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: status => <Tag color={status === 'Active' ? 'green' : 'red'} icon={status === 'Active' ? <UnlockOutlined /> : <LockOutlined />}>{status}</Tag>,
            filters: [{ text: 'Active', value: 'Active' }, { text: 'Inactive', value: 'Inactive' }],
            onFilter: (value, record) => record.status === value,
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
                <Space>
                    <Tooltip title="Edit Screen">
                        <Button
                            icon={<EditOutlined />}
                            size="small"
                            onClick={() => {
                                setEditingScreen(record);
                                form.setFieldsValue(record);
                                setScreenModalVisible(true);
                            }}
                        />
                    </Tooltip>
                    <Tooltip title="Delete Screen">
                        <Popconfirm
                            title="Are you sure you want to delete this screen?"
                            description="This will remove access control for this screen."
                            onConfirm={() => handleDeleteScreen(record.id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button icon={<DeleteOutlined />} size="small" danger />
                        </Popconfirm>
                    </Tooltip>
                </Space>
            ),
            width: 120,
        }
    ];

    // --------- Tabs content ----------
    const tabItems = [
        {
            key: 'users',
            label: <span style={{ fontSize: "18px", fontWeight: 500 }}><UserOutlined /> Users ({users.length})</span>,
            children: (
                <div>
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col>
                            {/* <Title level={4} style={{ margin: 0 }}>User Management</Title>
              <Text type="secondary">Manage system users and their access permissions</Text> */}
                        </Col>
                        <Col>
                            <Space>
                                <Search placeholder="Search users..." allowClear style={{ width: 250 }} onChange={(e) => setSearchText(e.target.value)} prefix={<SearchOutlined />} />
                                <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditingUser(null); form.resetFields(); setUserModalVisible(true); }}>Add User</Button>
                            </Space>
                        </Col>
                    </Row>

                    <Card>
                        <Row gutter={16} style={{ marginBottom: 16 }}>
                            <Col span={6}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#1890ff' }}>{users.length}</div><div>Total Users</div></Card></Col>
                            <Col span={6}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#52c41a' }}>{users.filter(u => u.status === true).length}</div><div>Active Users</div></Card></Col>
                            <Col span={6}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#fa8c16' }}>{users.filter(u => u.role === 'SuperAdmin').length}</div><div>Administrators</div></Card></Col>
                            <Col span={6}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#722ed1' }}>{users.filter(u => u.lastLogin === null).length}</div><div>Never Logged In</div></Card></Col>
                        </Row>

                        <Table columns={userColumns} dataSource={filteredUsers} rowKey="id" pagination={{ pageSize: 10, showSizeChanger: true, showQuickJumper: true, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} users` }} scroll={{ x: 1000 }} />
                    </Card>
                </div>
            )
        },
        {
            key: 'roles',
            label: <span style={{ fontSize: "18px", fontWeight: 500 }}><SafetyOutlined /> Roles ({roles.length})</span>,
            children: (
                <div>
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col>
                            {/* <Title level={4} style={{ margin: 0 }}>Role Management</Title>
              <Text type="secondary">Define roles and permissions for system access control</Text> */}
                        </Col>
                        <Col>
                            <Space>
                                <Search placeholder="Search roles..." allowClear style={{ width: 250 }} onChange={(e) => setSearchText(e.target.value)} prefix={<SearchOutlined />} />
                                <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditingRole(null); form.resetFields(); setRoleModalVisible(true); }}>Add Role</Button>
                            </Space>
                        </Col>
                    </Row>

                    <Card>
                        <Table columns={roleColumns} dataSource={filteredRoles} rowKey="id" pagination={{ pageSize: 10, showSizeChanger: true, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} roles` }} scroll={{ x: 1200 }} />
                    </Card>
                </div>
            )
        },
        {
            key: 'screens',
            label: <span style={{ fontSize: "18px", fontWeight: 500 }}><DesktopOutlined /> Screens ({screens.length})</span>,
            children: (
                <div>
                    <Row justify="space-between" align="middle" style={{ marginBottom: 16 }}>
                        <Col>
                        </Col>
                        <Col>
                            <Space>
                                <Search placeholder="Search screens..." allowClear style={{ width: 250 }} onChange={(e) => setSearchText(e.target.value)} prefix={<SearchOutlined />} />
                                <Button type="primary" icon={<PlusOutlined />} onClick={() => { setEditingScreen(null); form.resetFields(); setScreenModalVisible(true); }}>Add Screen</Button>
                            </Space>
                        </Col>
                    </Row>

                    <Card>
                        <Row gutter={16} style={{ marginBottom: 16 }}>
                            <Col span={8}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#1890ff' }}>{screens.length}</div><div>Total Screens</div></Card></Col>
                            <Col span={8}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#52c41a' }}>{screens.filter(s => s.status === 'Active').length}</div><div>Active Screens</div></Card></Col>
                            {/* <Col span={8}><Card size="small" style={{ textAlign: 'center' }}><div style={{ fontSize: 24, fontWeight: 'bold', color: '#fa8c16' }}>{Array.from(new Set(screens.map(s => s.category))).length}</div><div>Categories</div></Card></Col> */}
                        </Row>

                        <Table columns={screenColumns} dataSource={filteredScreens} rowKey="id" pagination={{ pageSize: 10, showSizeChanger: true, showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} screens` }} scroll={{ x: 1200 }} />
                    </Card>
                </div>
            )
        }
    ];

    // --------- Render main layout + Tabs ----------
    return (
        <div style={{ padding: 24, background: '#f5f5f5', minHeight: '100vh' }}>
            <Card style={{ marginBottom: 24 }}>
                <div style={{ textAlign: 'center', marginBottom: 24 }}>
                </div>

                <Tabs
                    activeKey={activeTab}
                    onChange={(key) => { setActiveTab(key); setSearchText(''); }}
                    items={tabItems}
                    size="large"
                />
            </Card>

            {/* ---------- User Modal ---------- */}
            <Modal
                title={editingUser ? 'Edit User' : 'Add User'}
                open={userModalVisible}
                onCancel={() => { setUserModalVisible(false); setEditingUser(null); form.resetFields(); }}
                footer={null}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleUserSubmit} initialValues={{ status: 'Active' }}>
                    <Form.Item name="name" label="Full Name" rules={[{ required: true, message: 'Please enter name' }]}>
                        <Input placeholder="Full name" />
                    </Form.Item>

                    <Form.Item name="email" label="Email" rules={[{ required: true, message: 'Please enter email' }, { type: 'email', message: 'Invalid email' }]}>
                        <Input placeholder="user@example.com" />
                    </Form.Item>
                    <Form.Item
                        name="role"
                        label="Role"
                        rules={[{ required: true, message: 'Please select role' }]}
                    >
                        <Select placeholder="Select role">
                            {roles.map((role) => (
                                <Select.Option key={role._id} value={role._id}>
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>
                    <Form.Item name="phone" label="Phone">
                        <Input placeholder="+91-7347856778" />
                    </Form.Item>

                    <Form.Item name="status" label="Status" valuePropName="checked">
                        <Switch checkedChildren="Active" unCheckedChildren="Inactive" defaultChecked />
                    </Form.Item>

                    <Form.Item style={{ textAlign: 'right' }}>
                        <Button onClick={() => { setUserModalVisible(false); setEditingUser(null); form.resetFields(); }} style={{ marginRight: 8 }}>Cancel</Button>
                        <Button type="primary" htmlType="submit">{editingUser ? 'Update' : 'Create'}</Button>
                    </Form.Item>
                </Form>
            </Modal>

            {/* ---------- Role Modal ---------- */}


            <Modal
                title={editingRole ? 'Edit Role' : 'Add Role'}
                open={roleModalVisible}
                onCancel={() => {
                    setRoleModalVisible(false);
                    setEditingRole(null);
                    form.resetFields();
                }}
                footer={null}
                destroyOnClose
                width={700}
                styles={{
                    body: {
                        maxHeight: 800,
                        overflowY: "hidden",
                        padding: "16px"
                    },
                    header: {
                        backgroundColor: "#fafafa"
                    },
                    footer: {
                        textAlign: "right"
                    }
                }}
            >
                <Form
                    form={form}
                    layout="vertical"
                    onFinish={handleRoleSubmit}
                    initialValues={{ status: 'Active', permissions: [] }}
                    style={{ flex: 1, display: 'flex', flexDirection: 'column' }}
                >
                    <Form.Item
                        name="name"
                        label="Role Name"
                        rules={[{ required: true, message: 'Please enter role name' }]}
                    >
                        <Input placeholder="e.g. Manager" />
                    </Form.Item>

                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={3} placeholder="Describe role responsibilities" />
                    </Form.Item>

                    <Form.Item
                        label={
                            <div style={{ display: "flex", justifyContent: "space-between" }}>
                                <span>Assign Screen & Permissions</span>
                                <Checkbox
                                    indeterminate={
                                        permissions.some(
                                            (p) => p.create || p.read || p.update || p.delete
                                        ) &&
                                        !permissions.every(
                                            (p) => p.create && p.read && p.update && p.delete
                                        )
                                    }
                                    checked={permissions.every(
                                        (p) => p.create && p.read && p.update && p.delete
                                    )}
                                    onChange={(e) => handleSelectAllGlobal(e.target.checked)}
                                    style={{ marginLeft: "8px" }}
                                >
                                    Select All
                                </Checkbox>
                            </div>
                        }
                        name="permissions"
                        style={{ flex: 1, minHeight: 0, marginBottom: 0 }}
                    >
                        <Table
                            dataSource={permissions}
                            columns={columns}
                            pagination={false}
                            rowKey="screenId"
                            bordered={false}
                            size="middle"
                            className="permission-table"
                            scroll={{ y: 250 }}
                        />
                    </Form.Item>
                    <Form.Item
                        name="status"
                        label="Status"
                        valuePropName="checked"
                        style={{ display: "inline-block" }}
                    >
                        <Switch checkedChildren="Active" unCheckedChildren="Inactive" />
                    </Form.Item>
                    {/* Footer Section inside same form */}
                    <div
                        style={{
                            borderTop: '1px solid #f0f0f0',
                            paddingTop: '5px',
                            backgroundColor: '#fff',
                            flexShrink: 0,
                            marginTop: 5,
                            textAlign: "right"
                        }}
                    >


                        <Button
                            onClick={() => {
                                setRoleModalVisible(false);
                                setEditingRole(null);
                                form.resetFields();
                            }}
                            style={{ marginRight: 8 }}
                        >
                            Cancel
                        </Button>
                        <Button type="primary" htmlType="submit">
                            {editingRole ? 'Update' : 'Create'}
                        </Button>
                    </div>
                </Form>
            </Modal>


            {/* ---------- Screen Modal ---------- */}
            <Modal
                title={editingScreen ? 'Edit Screen' : 'Add Screen'}
                open={screenModalVisible}
                onCancel={() => { setScreenModalVisible(false); setEditingScreen(null); form.resetFields(); }}
                footer={null}
                destroyOnClose
            >
                <Form form={form} layout="vertical" onFinish={handleScreenSubmit} initialValues={{ status: 'Active', roles: [] }}>
                    <Form.Item name="name" label="Screen Name" rules={[{ required: true, message: 'Please enter screen name' }]}>
                        <Input placeholder="e.g. Dashboard" />
                    </Form.Item>

                    <Form.Item name="path" label="Path" rules={[{ required: true, message: 'Please enter path' }]}>
                        <Input placeholder="/dashboard" />
                    </Form.Item>

                    <Form.Item name="description" label="Description">
                        <Input.TextArea rows={3} placeholder="What does this screen do?" />
                    </Form.Item>

                    <Form.Item name="roles" label="Select Options">
                        <Select
                            mode="multiple"
                            placeholder="Select Options"
                            allowClear
                        >
                            {options.map(role => (
                                // console.log(role),
                                < Select.Option key={role.id} value={role.name} >
                                    {role.name}
                                </Select.Option>
                            ))}
                        </Select>
                    </Form.Item>


                    <Form.Item name="status" label="Status" valuePropName="checked">
                        <Switch checkedChildren="Active" unCheckedChildren="Inactive" defaultChecked />
                    </Form.Item>

                    <Form.Item style={{ textAlign: 'right' }}>
                        <Button onClick={() => { setScreenModalVisible(false); setEditingScreen(null); form.resetFields(); }} style={{ marginRight: 8 }}>Cancel</Button>
                        <Button type="primary" htmlType="submit">{editingScreen ? 'Update' : 'Create'}</Button>
                    </Form.Item>
                </Form>
            </Modal>
        </div >
    );
};

export default AccessControlManagement;
